/* eslint-disable no-new */
import * as utilReportFinance from '@/api/reportFinance'

const actions = {
  listLabaRugi({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportFinance.listLabaRugi(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listNeraca({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportFinance.listNeraca(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reportFinance.js